import { PlusIcon } from '@radix-ui/react-icons'
import { Flex } from '@radix-ui/themes'
import { useWallet } from '@solana/wallet-adapter-react'
import type { SolanaConnectorProvider } from 'features/auth/utils/get-solana-connector-providers'
import { DataTestIDs } from 'shared/constants'
import { NeonSectionHeading } from 'shared/ui/neon'
import { WalletAppList } from './wallet-app-list'
import styles from '../neon-wallets.module.scss'

interface Props {
  isLinking: boolean
  onLink: (provider: SolanaConnectorProvider) => void
}

/**
 * Linking by signature (FE-305) for every wallet app (FE-306). The app the
 * user is connected with reads "another account", because linking it again
 * means switching to a second account inside that app first.
 */
export const LinkWalletSection: React.FC<Props> = ({ isLinking, onLink }) => {
  const { wallet } = useWallet()
  const connectedName = wallet?.adapter.name

  return (
    <Flex
      direction='column'
      gap='2'
    >
      <NeonSectionHeading
        icon={<PlusIcon />}
        title='Link another wallet'
      />
      <span className={styles.sectionText}>
        Pick the wallet app and sign the message. To add a second account from
        an app you already use, switch to that account in the app first. A
        wallet belongs to one XYRO account only and cannot be unlinked.
      </span>

      <WalletAppList
        variant='tiles'
        isBusy={isLinking}
        onPick={onLink}
        buttonTestId={DataTestIDs.buttonLinkWallet}
        getLabel={provider =>
          provider.walletName === connectedName ?
            `${provider.name} · another account`
          : provider.name
        }
      />
    </Flex>
  )
}
